export const search = async (app, searchTerm) => {
  try {
    const service = app.service('autocomplete');
    const result = await service.find({ query: { address: searchTerm } });

    return result;
  } catch (e) {
    throw e;
  }
};

export const fetchAddress = async (app, address) => {
  try {
    const service = app.service('geocode');
    const result = await service.find({ query: { address } });

    return result;
  } catch (e) {
    throw new Error(e);
  }
};
